var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../customers/belfort/widget-planner-conf/node_modules/@mecatran-projects/widget-planner/src/nunjucks-extensions/nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("A:/dev/workspace-node/bitbucket_repository/projects/customers/belfort/widget-planner-conf/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["../../../widget-planner/src/templates/selector.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<style>\r\n\r\n/*\r\n=============\r\nselector\r\n=============\r\n*/\r\n\r\n.route-selector{\r\n    display: inline;\r\n    padding: inherit;\r\n    color: inherit;\r\n    font-size: inherit;\r\n    font-weight: inherit;\r\n}\r\n\r\n.direction-origin, .direction-destination{ \r\n  display: inline-block;\r\n}\r\n/*\r\n==============\r\nautocomplete\r\n==============\r\n*/\r\n* {\r\n    box-sizing: border-box;\r\n  }\r\n  *:focus {\r\n    outline: none;\r\n  }\r\n  \r\n\r\n  \r\n  /*the container must be positioned relative:*/\r\n  .autocomplete {\r\n    position: relative;\r\n    /* display: inline-block; */\r\n  }\r\n  \r\n  input {\r\n    // border: 1px solid transparent;\r\n    background-color: #f1f1f1;\r\n  }\r\n  \r\n  input[type=text] {\r\n    background-color: #f1f1f1;\r\n    width: 100%;\r\n  }\r\n  \r\n  input[type=submit] {\r\n    background-color: DodgerBlue;\r\n    color: #fff;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .autocomplete-items {\r\n    position: absolute;\r\n    border: 1px solid #d4d4d4;\r\n    border-bottom: none;\r\n    border-top: none;\r\n    z-index: 9999;\r\n    /*position the autocomplete items to be the same width as the container:*/\r\n    top: 100%;\r\n    left: 0;\r\n    right: 0;\r\n  }\r\n  \r\n  .autocomplete-items div, .autocomplete-items h3 {\r\n    padding: 10px;\r\n    cursor: pointer;\r\n    background-color: #fff; \r\n    border-bottom: 1px solid #d4d4d4; \r\n  }\r\n  \r\n  /*when hovering an item:*/\r\n  .autocomplete-items div:hover {\r\n    background-color: #e9e9e9; \r\n  }\r\n  \r\n  /*when navigating through the items using the arrow keys:*/\r\n  .autocomplete-active {\r\n    background-color: DodgerBlue !important; \r\n    color: #ffffff; \r\n  }\r\n</style>\r\n\r\n\r\n\r\n<div class=\"direction-origin\">\r\n  <div class=\"label\">";
output += runtime.suppressValue((lineno = 89, colno = 48, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "getTrOriginSelectorLabel"), "getTrOriginSelectorLabel", context, [])), env.opts.autoescape);
output += "</div>\r\n  <div class=\"selector\"></div>\r\n</div>\r\n<div class=\"direction-destination\">\r\n  <div class=\"label\">";
output += runtime.suppressValue((lineno = 93, colno = 53, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "getTrDestinationSelectorLabel"), "getTrDestinationSelectorLabel", context, [])), env.opts.autoescape);
output += "</div>\r\n  <div class=\"selector\"></div>\r\n</div>\r\n\r\n\r\n\r\n\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["../../../widget-planner/src/templates/selector.njk"] , dependencies)